<div class="empty-details">
    <p class="empty-title">{{ title | translate }}</p>
    <p class="empty-hint" *ngIf="what">
        {{ "empty.chooseFromList" | translate: { what: what | translate } }}
    </p>
    <p class="empty-hint" *ngIf="!what && hint">{{ hint | translate }}</p>
</div>
